// extracted by mini-css-extract-plugin
module.exports = {"textInput":"TextInput_textInput__23uMr","spinner":"TextInput_spinner__3Rxid","inputError":"TextInput_inputError__3Vo8x","errorMessage":"TextInput_errorMessage__1agHR"};